module.exports = __webpack_public_path__ + "img/caav-lazy.f181157a.jpg";